import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { useRouter } from 'next/router';

const AppContext = createContext(undefined as TypeAny);

interface ContextWrapperProps {
  children: React.ReactNode;
}

export function AppContextWrapper({ children }: ContextWrapperProps) {
  const [campaign, setCampaign] = useState(null);
  const [campaignId, setCampaignId] = useState<string | null>(null);
  const [alert, setAlert] = useState(null);

  const router = useRouter();

  useEffect(() => {
    const handleRouteChange = (url: string) => {
      // eslint-disable-next-line no-useless-escape
      const isValidCampaignPath = /^\/connect\/campaigns\/[^\/]+(\/.*)?$/.test(url);

      if (!isValidCampaignPath) {
        setCampaign(null);
        setCampaignId(null);
      }
    };

    router.events.on('routeChangeStart', handleRouteChange);
    return () => router.events.off('routeChangeStart', handleRouteChange);
  }, []);

  const sharedState = useMemo(
    () => ({ alert, setAlert, campaign, setCampaign, campaignId, setCampaignId }),
    [alert, campaign, campaignId]
  );

  return <AppContext.Provider value={sharedState}>{children}</AppContext.Provider>;
}

export function useAppContext() {
  return useContext(AppContext);
}
